// Emojis dos seletores (chat, publicar postagem e fórum): mesma lista e mesma ordem em todos.
// Cada categoria tem múltiplo de 7 (as grades têm 7 colunas): a última linha fica sempre completa.
// Só emojis que o Windows 10 desenha (nada do Emoji 13+, que aparece como quadrado).
export const CATEGORIAS_EMOJI = [
  {
    chave: 'faces', titulo: 'Rostos',
    emojis: ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙','😋',
      '😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔','😐','😑','😶','😏','😒']
  },
  {
    chave: 'hands', titulo: 'Mãos',
    emojis: ['👋','🤚','🖐️','✋','🖖','👌','🙏','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🤝','👇','☝️','👍','👎',
      '✊','👊','🤛','🤜','👏','🙌','👐']
  },
  {
    chave: 'animals', titulo: 'Animais',
    emojis: ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐽','🐸','🐵','🙈','🙉','🙊','🐒','🐔',
      '🐧','🐦','🐤','🦆','🦅','🦉','🦇']
  },
  {
    chave: 'food', titulo: 'Frutas e comidas',
    emojis: ['🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🥑','🥦','🥕','🌽','🍞',
      '🧀','🍖','🍗','🍔','🍟','🍕','🌭']
  },
  {
    chave: 'signs', titulo: 'Símbolos',
    emojis: ['💯','💢','💥','💫','💦','💨','🕳️','💬','👁️‍🗨️','🗨️','🗯️','💭','💤','🔥','⭐','🌟','✨','⚡','☄️','❤️','🧡',
      '💛','💚','💙','💜','🖤','💔','💕','✅','❌','❓','❗','⚠️','🔔','🔍']
  },
  {
    chave: 'objects', titulo: 'Objetos',
    emojis: ['📱','💻','⌨️','🖥️','🖨️','🖱️','🖲️','🕹️','🗜️','💾','💿','📀','📼','📷','📸','📹','🎥','📽️','🎞️','📞','☎️',
      '📟','📠','📺','📻','🎙️','🎚️','🎛️','🧭','⏰','⌚','💡','🔧','🔑','📦']
  },
  {
    chave: 'flags', titulo: 'Bandeiras', bandeiras: true,
    emojis: ['🇧🇷','🇵🇹','🇺🇸','🇦🇷','🇺🇾','🇵🇾','🇨🇱','🇧🇴','🇵🇪','🇨🇴','🇻🇪','🇲🇽','🇨🇦','🇪🇸','🇫🇷','🇮🇹','🇩🇪','🇬🇧','🇯🇵','🇨🇳','🇦🇴',
      '🇲🇿','🇿🇦','🇮🇳','🇦🇺','🏁','🏳️','🏴']
  }
];

// O Windows não tem desenho de bandeira (mostra as letras do país): nas bandeiras usa a fonte Noto Color Emoji
export const ESTILO_BANDEIRA = { fontFamily: "'Noto Color Emoji', 'Segoe UI Emoji', 'Apple Color Emoji', sans-serif" };
